import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import "./puja-campaign-frame.scss";
import Image from "next/image";

import mobileBg from "@/../public/campaign/puja-2025/mobile-bg.webp";
import tabletBg from "@/../public/campaign/puja-2025/tablet-bg.webp";
import laptopBg from "@/../public/campaign/puja-2025/laptop-bg.webp";

export default function Frame() {
  const [isMobileView, setIsMobileView] = useState(false);
  const [isTabletView, setIsTabletView] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width:480px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1024px)" });

  useEffect(() => {
    setIsMobileView(isMobile);
    setIsTabletView(isTablet);
  }, [isMobile, isTablet]);

  return (
    <Image
      src={isMobileView ? mobileBg : isTabletView ? tabletBg : laptopBg}
      alt="Puja Campaign Background"
      objectFit="cover"
      className="PujaCampaignFrame"
    />
  );
}
